import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, Grid, Typography } from '@mui/material';
import { useLanguage } from '../contexts/LanguageContext';

const MapRankSelection = ({ maps, ranks, selectedMap, selectedRank, onMapChange, onRankChange }) => {
  const { t } = useLanguage();
  return (
    <Box sx={{ mb: 2 }}>
      <Typography 
        variant="h5" 
        gutterBottom
        sx={{ 
          color: 'white',
          fontWeight: 'bold',
          position: 'relative',
          paddingBottom: 1,
          mb: 2,
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '40px',
            height: '3px',
            backgroundColor: '#fbdb2b',
            borderRadius: '2px'
          }
        }}
      >
        {t('gameSettings')}
      </Typography>
      
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel 
              id="map-select-label"
              sx={{ 
                color: 'rgba(255,255,255,0.7)',
                '&.Mui-focused': {
                  color: '#fbdb2b'
                }
              }}
            >
              {t('map')}
            </InputLabel>
            <Select
              labelId="map-select-label"
              value={selectedMap}
              label="Map"
              onChange={(e) => onMapChange(e.target.value)}
              sx={{ 
                color: 'white',
                '.MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(255,255,255,0.3)',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#fbdb2b',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(255,255,255,0.5)',
                },
                '.MuiSvgIcon-root': {
                  color: 'rgba(255,255,255,0.7)',
                }
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    backgroundColor: '#2b3340',
                    color: 'white',
                    '& .MuiMenuItem-root': {
                      '&:hover': {
                        backgroundColor: 'rgba(251, 219, 43, 0.1)',
                      },
                      '&.Mui-selected': {
                        backgroundColor: 'rgba(251, 219, 43, 0.2)',
                        '&:hover': {
                          backgroundColor: 'rgba(251, 219, 43, 0.3)',
                        }
                      }
                    }
                  }
                }
              }}
            >
              <MenuItem value="">
                <em>{t('anyMap')}</em>
              </MenuItem>
              {maps.map((map) => (
                <MenuItem key={map.id} value={map.id} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  {map.image && (
                    <Box
                      component="img"
                      src={map.image}
                      alt={map.name}
                      sx={{
                        width: 50,
                        height: 50,
                        objectFit: 'cover',
                        borderRadius: 1
                      }}
                    />
                  )}
                  {map.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel 
              id="rank-select-label"
              sx={{ 
                color: 'rgba(255,255,255,0.7)',
                '&.Mui-focused': {
                  color: '#fbdb2b'
                }
              }}
            >
              {t('rank')}
            </InputLabel>
            <Select
              labelId="rank-select-label"
              value={selectedRank}
              label="Rank"
              onChange={(e) => onRankChange(e.target.value)}
              sx={{ 
                color: 'white',
                '.MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(255,255,255,0.3)',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#fbdb2b',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(255,255,255,0.5)',
                },
                '.MuiSvgIcon-root': {
                  color: 'rgba(255,255,255,0.7)',
                }
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    backgroundColor: '#2b3340',
                    color: 'white',
                    '& .MuiMenuItem-root': {
                      '&:hover': {
                        backgroundColor: 'rgba(251, 219, 43, 0.1)',
                      },
                      '&.Mui-selected': {
                        backgroundColor: 'rgba(251, 219, 43, 0.2)',
                        '&:hover': {
                          backgroundColor: 'rgba(251, 219, 43, 0.3)',
                        }
                      }
                    }
                  }
                }
              }}
            >
              <MenuItem value="">
                <em>{t('anyRank')}</em>
              </MenuItem>
              {ranks.map((rank) => (
                <MenuItem key={rank.id} value={rank.id}>
                  {rank.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MapRankSelection;